module.exports = __webpack_public_path__ + "media/images/project/this-week-d690084933da09ce41ba9a5a7f979070.svg";